export const ELEMENT_CONFIG = {
  "Foundations": [
    "Excavation & B/F",
    "Individual Footing",
    "Combined Footing",
    "Wall Footings",
    "Mat Foundation (finished floor)",
    "Pit Slab/Footing",
    "Pit Walls"
  ],
  "SOG": [
    "Subgrade Prep",
    "Place & Finish"
  ],
  "Walls": [
    "1-sided Foundation Walls",
    "Curbs/Knee Walls (up to 2')",
    "2-sided Walls >4'",
    "2-sided Walls 2'-4'",
    "Pilasters"
  ],
  "Columns/Posts": [
    "Columns up to 10'",
    "Columns over 10'",
    "Round Columns up to 10'",
    "Round Columns over 10'"
  ],
  "Shear Walls": [
    "Walls up to 10'",
    "Walls over 10'"
  ],
  "Elevated Slabs": [
    "Beams/Girders",
    "Framed Slab - Flat Slab",
    "Framed Slab - Drops",
    "Precast Stairs"
  ],
  "SOMD": ["SOMD"],
  "Comeback Work": [
    "Toppings/Built-ups",
    "Pan Filled Stairs",
    "MEP Pads"
  ],
  "Punch List": ["Punch List"],
  "Job Labor": ["Shotcrete Crew Assist"]
};

export const PHASES = [
  { value: 'forming', label: 'Forming' },
  { value: 'pouring', label: 'Pouring' },
  { value: 'stripping', label: 'Stripping' },
  { value: 'punch', label: 'Punch Out' }
];